import {createSignal} from '@pexip/signal';

export const browserNotificationPermissionSignal = createSignal({
    name: 'browserNotification:permissionChange',
});
